export const filterPermissionsMenu = (menuArray) => {
  const { permissions, admin } = JSON.parse(localStorage.getItem('user')).user;
  return menuArray.filter((menu) => {
    if (typeof menu.permissions === 'boolean' && menu.permissions === true) {
      return true;
    }

    if (admin) {
      return true;
    }

    if (menu.hasOwnProperty('subNavigationItems') && menu.subNavigationItems.length > 0) {
      menu.subNavigationItems = filterPermissionsMenu(menu.subNavigationItems);
      if (menu.subNavigationItems.length > 0) {
        return true;
      }
    }

    if (menu.hasOwnProperty('items') && menu.items.length > 0) {
      menu.items = filterPermissionsMenu(menu.items);
      if (menu.items.length > 0) {
        return true;
      }
    }

    if (menu.hasOwnProperty('permissions') && menu.permissions.length > 0) {
      return menu.permissions.some((permission) => permissions.includes(permission));
    }

    return false;
  });
};

export const checkPermission = (permission) => {
  const { permissions, admin } = JSON.parse(localStorage.getItem('user')).user;

  if (permission === true || admin) {
    return true;
  }

  if (permission === 'ADMIN' && admin) {
    return true;
  }

  if (typeof permission === 'string') {
    return permissions.includes(permission);
  }

  if (Array.isArray(permission)) {
    return permission.some((p) => permissions.includes(p));
  }

  return false;
};
